import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import FooterEN from "../Symbols/FooterEN";
import "../../stylesheets/Produkte.css";
import { Helmet } from "react-helmet-async";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";

class ProduktEN extends Component {
  constructor(props) {
    super(props);
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    this.state = {
      file: null,
      numPages: 0,
      pageNumber: 1,
      product: [],
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  nextPage = () => {
    const currentPageNumber = this.state.pageNumber;
    let nextPageNumber;

    if (currentPageNumber + 1 > this.state.numPages) {
      nextPageNumber = 1;
    } else {
      nextPageNumber = currentPageNumber + 1;
    }

    this.setState({
      pageNumber: nextPageNumber,
    });
  };

  backPage = () => {
    const currentPageNumber = this.state.pageNumber;
    let nextPageNumber;

    if (currentPageNumber - 1 < 1) {
      nextPageNumber = 1;
    } else {
      nextPageNumber = currentPageNumber - 1;
    }

    this.setState({
      pageNumber: nextPageNumber,
    });
  };

  componentDidMount() {
    fetch(
      `https://api.airtable.com/v0/app1t0Kdg1xsbWoWn/Produkte/${window.location.pathname.split("/")[3]
      }`, { headers: { 'Authorization': 'Bearer patSxqK40aDpd0iY6.beedbae8aef0d8ef37eaa0268af4654eb5113643efb69777ef67367c2031ee09' } }
    )
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({ product: data, file: data.fields.Datenblatt_3 ? data.fields.Datenblatt_3[0].url : data.fields.Datenblatt_New[0].url });
      })
      .catch((err) => {
        // Error :(
      });
  }

  render() {
    const { pageNumber, numPages } = this.state;
    if (
      this.state.product &&
      Object.keys(this.state.product).length !== 0 &&
      Object.getPrototypeOf(this.state.product) === Object.prototype
    ) {
      return (
        <div className="content">
          <Helmet>
            <title>Pancon - {this.state.product.fields.Name_Neu}</title>
            <meta
              name="description"
              content="Pancon offers various types of connectors. Our
products are the optimal solution for your requirements in the field of
connectors"
            />
            <meta
              property="og:title"
              content={"Pancon - " + this.state.product.fields.Name_Neu}
            />
            <meta
              property="og:description"
              content="Pancon offers various types of connectors. Our
products are the optimal solution for your requirements in the field of
connectors"
            />
          </Helmet>
          <NavEN />
          <div className="section first flex center-v center-h">
            <div className="medium flex center-h product-p">
              <div className="heading1-cont flex center-v center-h">
                <div className="heading-deco m-right-3"></div>
                <h1>{this.state.product.fields.Name_Neu}</h1>
              </div>
              <div className="flex center-h full-width col center-v">
                {this.state.product.fields.Bild != undefined &&
                  <img className="product-img" src={this.state.product.fields.Bild[0].url}></img>
                }
                <p className="body">
                  {this.state.product.fields.Marketing_Text_EN ?
                    this.state.product.fields.Marketing_Text_EN : this.state.product.fields.Beschreibung_EN_Neu
                  }
                </p>
              </div>
              <div className="card-cont small">
                <div className="card small">
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Produktreihe}
                    </span>
                    <span className="prod-attr-desc">Series</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Kategorie.join(", ")}
                    </span>
                    <span className="prod-attr-desc">Category</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Pitch}
                    </span>
                    <span className="prod-attr-desc">Pitch</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Gender_EN}
                    </span>
                    <span className="prod-attr-desc">Gender</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Number_of_Rows}
                    </span>
                    <span className="prod-attr-desc">Number of Rows</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Polarized_EN}
                    </span>
                    <span className="prod-attr-desc">Polarized</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Profile}
                    </span>
                    <span className="prod-attr-desc">Profile</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Locating_Peg_EN}
                    </span>
                    <span className="prod-attr-desc">Locating Peg</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Orientation}
                    </span>
                    <span className="prod-attr-desc">Orientation</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Elevated}
                    </span>
                    <span className="prod-attr-desc">Elevated</span>
                  </div>
                  <div className="card-desc flex center-h col">
                    <span className="prod-attr">
                      {this.state.product.fields.Connectivity_EN}
                    </span>
                    <span className="prod-attr-desc">Connectivity</span>
                  </div>
                </div>
              </div>
              {this.state.file ? (
                <div className="flex col center-h m-top-4">
                  <h2>Data sheet</h2>
                  <Document
                    file={this.state.file}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                  >
                    <Page pageNumber={pageNumber} />
                  </Document>
                  <div id="navigation_controls" className="flex col center-h">
                    {this.state.file ? (
                      <p className="body center">
                        Page {pageNumber} of {numPages}
                      </p>
                    ) : null}
                    <div className="flex center-h">
                      <button onClick={this.backPage} className="default m-right-1">
                        Previous Page
                      </button>
                      <button onClick={this.nextPage} className="default">
                        Next Page
                      </button>
                    </div>
                  </div>
                  <a
                    target="_blank"
                    href={this.state.product.fields.Datenblatt_3 ?
                      this.state.product.fields.Datenblatt_3[0].url : this.state.product.fields.Datenblatt_New[0].url}
                  >
                    <div className="flex center-h marg-top">
                      <button className="default">Download</button>
                    </div>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <FooterEN />
        </div>
      );
    }
  }
}

export default ProduktEN;
